import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=e6e4a744&scoped=true"
import script from "./Template.vue?vue&type=script&setup=true&lang=js"
export * from "./Template.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Template.vue?vue&type=style&index=0&id=e6e4a744&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e4a744",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6e4a744')) {
      api.createRecord('e6e4a744', component.options)
    } else {
      api.reload('e6e4a744', component.options)
    }
    module.hot.accept("./Template.vue?vue&type=template&id=e6e4a744&scoped=true", function () {
      api.rerender('e6e4a744', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/preventive-maintenance/templates/items/Template.vue"
export default component.exports